
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"17","height":"17","fill":"#231F20","rx":"1"}}),_c('path',{attrs:{"fill":"#FF5F00","d":"M10.542 4.95H6.485v7.29h4.057z"}}),_c('path',{attrs:{"fill":"#EB001B","d":"M6.742 8.594c0-1.417.657-2.769 1.765-3.645a4.637 4.637 0 0 0-6.518.786 4.634 4.634 0 0 0 .8 6.504 4.625 4.625 0 0 0 5.73 0 4.64 4.64 0 0 1-1.777-3.645"}}),_c('path',{attrs:{"fill":"#F79E1B","d":"M16.016 8.596A4.634 4.634 0 0 1 8.52 12.24a4.645 4.645 0 0 0 .773-6.517 5 5 0 0 0-.773-.773 4.62 4.62 0 0 1 6.504.785c.645.814.994 1.822.992 2.86"}})])
          )
        }
      }
    